
import { defineComponent, ref, onMounted, onUnmounted } from "vue";
import { contentWidthFluid } from "@/core/helpers/config";

interface NavigatorWithKeyboard extends Navigator {
  keyboard: {
    lock: () => Promise<void>;
    unlock: () => Promise<void>;
  };
}

export default defineComponent({
  name: "default-layout-content",
  components: {},
  methods: {
    scrollTop() {
      const scrollTarget = this.$refs.fullScreenContent as HTMLElement;
      scrollTarget.scrollTo({
        top: 0,
        behavior: "smooth",
      });
    },
    async exibirContentFullScreen(): Promise<void> {
      const elem = this.$refs.fullScreenContent as HTMLElement;
      if (!document.fullscreenElement) {
        elem
          .requestFullscreen()
          .then(async () => {
            this.isFullscreen = true;
            var nav = navigator as NavigatorWithKeyboard;
            if ("keyboard" in nav && "lock" in nav.keyboard) {
              await nav.keyboard.lock();
            }
          })
          .catch((err: Error) => {
            alert(
              `Não foi possível habilitar o modo Full Screen: ${err.message} (${err.name})`
            );
          });
      } else {
        document.exitFullscreen().then(async () => {
          this.isFullscreen = false;
          var nav = navigator as NavigatorWithKeyboard;
          if ("keyboard" in nav && "lock" in nav.keyboard) {
            await nav.keyboard.unlock();
          }
          this.isScrolltopActive = false;
        });
      }
    },

    async handleArrowKeys(event) {
      if (event.key === "F11") {
        event.preventDefault();
        await this.exibirContentFullScreen();
      }
    },

    handlerFullScreen() {
      this.isFullscreen = !!document.fullscreenElement;
    },

    handlerScroll() {
      const scrollTarget = this.$refs.fullScreenContent as HTMLElement;
      const scrollTop = scrollTarget.scrollTop;
      const offset = 200;
      this.isScrolltopActive = scrollTop > offset;
    },
  },
  setup() {
    const isScrolltopActive = ref(false);

    const checkScrolltopAttribute = () => {
      isScrolltopActive.value = document.body.hasAttribute("data-kt-scrolltop");
    };

    let observer: MutationObserver;

    onMounted(() => {
      checkScrolltopAttribute();

      observer = new MutationObserver(() => {
        checkScrolltopAttribute();
      });

      observer.observe(document.body, {
        attributes: true,
        attributeFilter: ["data-kt-scrolltop"],
      });
    });

    onUnmounted(() => {
      if (observer) {
        observer.disconnect();
      }
    });

    return {
      contentWidthFluid,
      isScrolltopActive,
    };
  },
  mounted() {
    window.addEventListener("keydown", this.handleArrowKeys);
    document.addEventListener("fullscreenchange", this.handlerFullScreen);
    (this.$refs.fullScreenContent as HTMLElement).addEventListener(
      "scroll",
      this.handlerScroll
    );
  },
  beforeUnmount() {
    window.removeEventListener("keydown", this.handleArrowKeys);
    document.removeEventListener("fullscreenchange", this.handlerFullScreen);
    (this.$refs.fullScreenContent as HTMLElement).removeEventListener(
      "scroll",
      this.handlerScroll
    );
  },
  data() {
    return {
      isFullscreen: false,
    };
  },
});
